import { apiRequest } from "../Utils/APIUtils";
import { debugLog } from "../Utils/LogUtils";
import useEnrolmentState from "../State/useEnrolmentState";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import EnrolmentTile from "../ManageEnrolments/EnrolmentTile";
import './FamilyEnrolments.css';
import ModalPopup from "../ModalPopup/ModalPopup";
import React, { useState } from "react";

const FamilyEnrolments = ({ state }) => {
    const { t } = useTranslation();
    const defaultEnrolmentState = useEnrolmentState();
    const [enrolmentToDelete, setEnrolmentToDelete] = useState(null);
    const navigate = useNavigate();

    const confirmDeleteEnrolment = (enrolmentId) => {

        apiRequest(`api/enrolment/${enrolmentId}`, 'DELETE')
            .then(() => {
                state.setApplication({
                    ...state.application,
                    childApplications: state.application.childApplications.filter(childApp => childApp._id !== enrolmentId),
                    childApplicationIds: state.application.childApplicationIds.filter(childAppId => childAppId !== enrolmentId)
                });
            })
            .catch(error => {
                //TODO: SHouldn't really use alerts...
                alert('Error deleting enrolment');
                console.error('Error:', error)
            })
    }


    const handleEnrolAdditionalBeneficiary = (masterApplicationId) => {
        if (!state) { return; }
        if (!state.enrollment) { return; }
        if (!state.enrollment._id) { return; }
        if (!masterApplicationId) { return; }

        //We create a new child enrolment based on the parent
        const newChildEnrolmentState = {
            ...defaultEnrolmentState,
            application: {
                ...defaultEnrolmentState.application,
                masterApplicationId: masterApplicationId,
                tcpEmail: state.application.tcpEmail,
                tcpName: state.application.tcpName,
                tcpPhone: state.application.tcpPhone,
                tcpRelationship: state.application.tcpRelationship,
                bank: state.application.bank,
                bankName: state.application.bankName,
                cardCVV: state.application.cardCVV,
                cardNumber: state.application.cardNumber,
                cardType: state.application.cardType,
                creditSubscriber: state.application.creditSubscriber,
                expiryMonth: state.application.expiryMonth,
                expiryYear: state.application.expiryYear,
                transit: state.application.transit,
                accountNumber: state.application.accountNumber,
            },
            plan: {
                ...defaultEnrolmentState.plan,
                initialDepositMethod: state.plan.initialDepositMethod,
                ongoingDepositMethod: state.plan.ongoingDepositMethod,
            },
            common: state.common,
            subscriber: state.subscriber,
            jointSubscriber: state.jointSubscriber,
            knowYourClient: state.knowYourClient,
            dependant: state.dependant,
            dependant2: state.dependant2,
            dependant3: state.dependant3,
            dependant4: state.dependant4,
        }

        apiRequest(`api/child-enrolment/${masterApplicationId}`, 'POST', newChildEnrolmentState)
            .then(response => {
                debugLog(response); // Handle success response
                if (response && response._id) {
                    navigate(`/enrolment/${response._id}/Basic`);
                }


            }).catch(error => {
                console.error('There was a problem with your fetch operation:', error);
            });
    }

    return (
        <div className={'family-enrolments'}>
            {state && state.enrollment.state === 'pre-docusign' && state.application && !state.application.masterApplicationId &&
                <div>
                    <button onClick={() => { handleEnrolAdditionalBeneficiary(state.enrollment._id) }}>{t("Enrol Additional Beneficiary")}</button>
                </div>
            }
            {state && state.enrollment.state === 'pre-docusign' && state.application && state.application.masterApplicationId &&
                <div>
                    <button onClick={() => { handleEnrolAdditionalBeneficiary(state.application.masterApplicationId) }}>{t("Enrol Additional Beneficiary")}</button>
                </div>
            }
            {state && state.enrollment.state !== 'pre-docusign' && state.application && !state.application.masterApplicationId &&
                <div className={'info centered-text'}>
                    {t('This enrolment has been submitted for signing and can no longer be used to add more Family Enrolments.')}
                </div>
            }

            {state && state.application && state.application.childApplications && state.application.childApplications.length > 0 &&
                <div>
                    <div className={'info centered-text'}>
                        {t('You are currently viewing the primary enrolment of a Family Enrolment. Secondary enrolments are shown below.')}
                    </div>
                    <div className={'info centered-text'}>
                        {t('Know Your Client and Subscriber details can only be changed on the primary enrolment.')}
                    </div>
                    {state.application.childApplications.map((childApp, index) => {
                        return (
                            <EnrolmentTile
                                enrolment={childApp}
                                setEnrolmentToDelete={childApp && childApp.state === 'pre-docusign' ? setEnrolmentToDelete : null}
                            />
                        )
                    })}
                </div>
            }

            {state && state.application && state.application.masterApplicationId && state.application.masterApplication &&
                <div>
                    <div className={'info centered-text'}>
                        {t('You are currently viewing a secondary enrolment that is part of a Family Enrolment. The primary enrolment is shown below.')}
                    </div>
                    <div className={'info centered-text'}>
                        {t('Know Your Client and Subscriber details can only be changed on the primary enrolment.')}
                    </div>
                    <EnrolmentTile
                        enrolment={state.application.masterApplication}
                    />
                </div>
            }

            {enrolmentToDelete &&
                <ModalPopup
                    show={true}
                    onClose={() => setEnrolmentToDelete(null)}
                >
                    <div>Are you sure you want to delete this enrolment? This cannot be undone.</div>
                    <div>
                        <button className={'clickable'}
                            onClick={() => {
                                confirmDeleteEnrolment(enrolmentToDelete);
                                setEnrolmentToDelete(null);
                            }}>
                            Yes
                        </button>

                        <button className={'clickable'}
                            onClick={() => {
                                setEnrolmentToDelete(null);
                            }}>
                            No
                        </button>
                    </div>

                </ModalPopup>
            }
        </div>
    )
}

export default FamilyEnrolments;